import { render, staticRenderFns } from "./serviceHall.vue?vue&type=template&id=45da4197&scoped=true"
import script from "./serviceHall.vue?vue&type=script&lang=js"
export * from "./serviceHall.vue?vue&type=script&lang=js"
import style0 from "./serviceHall.vue?vue&type=style&index=0&id=45da4197&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45da4197",
  null
  
)

export default component.exports